import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class SettingsServerRoute extends AuthenticatedRoute {}
